import { LocalService } from 'src/app/services/local.service';
import { AuswahlAnzeigeAllgemein } from './auswahl-anzeige-allgemein.model';
import { ErgebnisQuelleFlaeche } from './ergebnis-quelle-flaeche.model';

export class AuswahlAnzeigeFlaechenquelle extends AuswahlAnzeigeAllgemein {
  flaechenquellenart: string;
  emissionsfaktorGeGv: number;
  emissionsminderungsmassnahme: string;
  wirkungsgrad: number;
  durchmesser: number;
  laengeHoehe: number;
  breite: number;
  flaeche: number;

  constructor(
    ergebnisQuelleFlaeche: ErgebnisQuelleFlaeche,
    localService: LocalService
  ) {
    super(ergebnisQuelleFlaeche);

    this.flaechenquellenart = localService.flaechenquellartList.value.filter(
      (item) =>
        item.idFlaechenquellart == ergebnisQuelleFlaeche.idFlaechenquellart
    )[0].flaechenquellart;
    this.emissionsfaktorGeGv = ergebnisQuelleFlaeche.emissionsfaktorGeGv;



    this.emissionsminderungsmassnahme =
      localService.minderungsmassnahmeFlaechenList.value.filter(
        (item) =>
          item.idMmFlaechenZuord == ergebnisQuelleFlaeche.idMmFlaechenZuord
      )[0].minderungsmassnahmeWirkungsgrad;
    this.wirkungsgrad = ergebnisQuelleFlaeche.wirkungsgrad;
    this.durchmesser = ergebnisQuelleFlaeche.durchmesser;
    this.laengeHoehe = ergebnisQuelleFlaeche.laengeHoehe;
    this.breite = ergebnisQuelleFlaeche.breite;
    this.flaeche = ergebnisQuelleFlaeche.flaeche;
  }
}
